import { TalkRoom } from "~/entities/TalkRoom";

export class TalkRoomEditInfo {
  name: string;
  description: string;
  canUserPost: boolean;
  isLimited: boolean;
  isPublished: boolean;
  isArchive: boolean;
  defaultNotification: boolean;
  displayOrder: number;
  dmUserId: string | null;

  private constructor({
    name = "",
    description = "",
    canUserPost = true,
    isLimited = true,
    isPublished = true,
    isArchive = false,
    defaultNotification = true,
    displayOrder = 1,
    dmUserId = null as string | null,
  }) {
    this.name = name;
    this.description = description;
    this.canUserPost = canUserPost;
    this.isLimited = isLimited;
    this.isPublished = isPublished;
    this.isArchive = isArchive;
    this.defaultNotification = defaultNotification;
    this.displayOrder = displayOrder;
    this.dmUserId = dmUserId;
  }

  static copy(src: TalkRoomEditInfo): TalkRoomEditInfo {
    return new TalkRoomEditInfo(src);
  }

  static fromNextDisplayOrder(displayOrder: number): TalkRoomEditInfo {
    return new TalkRoomEditInfo({ displayOrder: displayOrder });
  }

  static fromTalkRoom(talkRoom: TalkRoom): TalkRoomEditInfo {
    return new TalkRoomEditInfo({
      name: talkRoom.roomName,
      description: talkRoom.description,
      canUserPost: !talkRoom.isOnlyOwnerPost,
      isLimited: !talkRoom.isFree,
      isPublished: talkRoom.published,
      isArchive: talkRoom.isArchive,
      defaultNotification: talkRoom.isLineNotify,
      displayOrder: talkRoom.displayOrder,
    });
  }

  static forDM(clientUserId: string, clientUserName: string): TalkRoomEditInfo {
    return new TalkRoomEditInfo({
      name: `DM：${clientUserName}`,
      description: "講師とのダイレクトメッセージ",
      dmUserId: clientUserId,
    });
  }
}
